const getRideType = (rideType) => {
    switch (rideType) {
        case 'car-go':
            return 'red-go';
        case 'car-x':
            return 'red-x';
        case 'car-save':
            return 'red-save';
        default:
            return 'red-x';
    }
}

export default getRideType;